<template>
    <div class="nemid-container">
        <tabs :options="{ useUrlFragment: false }">
            <tab name="Nøglekort">
                <nemid-signature
                    id="nemid_iframe"
                    v-if="jsConfig"
                    width="200"
                    height="280"
                    :src="nemid_js_endpoint"
                    :config="jsConfig"
                    @success="signed"
                    @error="error"
                />
            </tab>

            <tab name="Nøglefil">
                <nemid-signature
                    id="codefile_iframe"
                    v-if="cfConfig"
                    width="300"
                    height="150"
                    :src="nemid_cf_endpoint"
                    :config="cfConfig"
                    @success="signed"
                    @error="error"
                />
            </tab>
        </tabs>
    </div>
</template>

<script>
import NemidSignature from "../../../vue-nemid/components/NemidSignature";

export default {
    name: "CustomContractNemidSignature",
    components: {
        NemidSignature
    },
    data: function() {
        return {
            nemidResponse: '',
            nemid_js_endpoint: window.config.nemid_js_endpoint,
            jsConfig: {},
            nemid_cf_endpoint: window.config.nemid_cf_endpoint,
            cfConfig: {},
            key: Math.trunc((new Date()).getTime() * 10)
        }
    },
    methods: {
        clear() {
            this.key = Math.trunc((new Date()).getTime() * 10);
        },
        signed(response) {
            this.$emit('success', response);
        },
        error(message) {
            this.$swal(message, [], 'error');
        },
    },
    mounted() {
        window.axios.get('/nemid/javascript').then((response) => this.jsConfig = response.data);
        window.axios.get('/nemid/codefile').then((response) => this.cfConfig = response.data);
    }

}

</script>
<style lang="scss">

#nemid_iframe, #codefile_iframe {
    border: none;
}

.nemid-container {
    margin-top: 0;

    .tabs-component > ul {
        border: none;
        padding: 0 0 20px 0;
        margin: 0;
    }
}

</style>
